export default "__VITE_ASSET__DcHzR7sB__"